import React from "react";
import { motion } from "framer-motion";
import {
  CheckCircle,
  Shield,
  FileText,
  Users,
  Globe2
} from "lucide-react";
import Navbar from "../../components/Navbar";

const halalPoints = [
  {
    title: "Halal Management System",
    desc: "Development and implementation of Halal Management System aligned with international Halal certification bodies.",
    icon: Shield
  },
  {
    title: "Raw Material & Supplier Verification",
    desc: "Verification of ingredients, suppliers, and sourcing to ensure full Halal compliance.",
    icon: CheckCircle
  },
  {
    title: "Documentation & Procedures",
    desc: "Preparation of Halal manuals, SOPs, risk assessments, and records required for certification.",
    icon: FileText
  },
  {
    title: "Training & Awareness",
    desc: "Halal awareness and operational training for management and production staff.",
    icon: Users
  },
  {
    title: "Global Halal Market Access",
    desc: "Certification support to expand business into Muslim-majority and international Halal markets.",
    icon: Globe2
  }
];

const HalalCertification = () => {
  return (
    <>
    <Navbar />
    <section className="bg-gray-50 py-14 px-4 sm:px-6 lg:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto grid grid-cols-1 lg:grid-cols-2 gap-14 items-start">

        {/* ================= LEFT CONTENT ================= */}
        <motion.div
          initial={{ opacity: 0, x: -40 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true, amount: 0.4 }}
          transition={{ duration: 0.7, ease: "easeOut" }}
        >
          <h2 className="text-3xl md:text-4xl font-bold text-transparent bg-clip-text bg-[var(--bg-primary)] mb-5">
            Halal Certification
          </h2>

          <div className="w-20 h-1 bg-[var(--bg-primary)] rounded-full mb-6"></div>

          <p className="text-gray-600 text-base md:text-lg leading-relaxed mb-6">
            MBA Solutions provides professional Halal certification consultancy
            services to help organizations comply with Halal requirements,
            ensuring integrity, transparency, and trust across the food and
            non-food supply chain.
          </p>

          <p className="text-gray-600 leading-relaxed">
            Our experts assist businesses in meeting Halal standards through
            systematic implementation, documentation, training, and audit
            readiness—supporting both local and international certification
            bodies.
          </p>

          {/* CTA */}
          <motion.button
            whileHover={{ scale: 1.05 }}
            whileTap={{ scale: 0.97 }}
            className="mt-10 inline-flex items-center gap-2 px-8 py-3 rounded-full bg-[var(--bg-primary)] text-white font-semibold shadow-lg hover:shadow-2xl transition-all duration-300"
          >
            Get Halal Certification Support
          </motion.button>
        </motion.div>

        {/* ================= RIGHT TIMELINE STYLE BLOCKS ================= */}
        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-6 top-0 bottom-0 w-[2px] bg-[var(--bg-primary)]/30 hidden sm:block"></div>

          <div className="space-y-8">
            {halalPoints.map((item, index) => {
              const Icon = item.icon;
              return (
                <motion.div
                  key={index}
                  initial={{ opacity: 0, x: 40 }}
                  whileInView={{ opacity: 1, x: 0 }}
                  viewport={{ once: true, amount: 0.3 }}
                  transition={{ duration: 0.6, ease: "easeOut", delay: index * 0.1 }}
                  whileHover={{
                    scale: 1.03,
                    boxShadow: "0px 20px 40px rgba(34,197,94,0.25)"
                  }}
                  className="relative bg-white rounded-2xl p-6 pl-16 shadow-lg border border-gray-100"
                >
                  {/* Icon */}
                  <div className="absolute left-2 top-6 w-10 h-10 rounded-full bg-[var(--bg-primary)] text-white flex items-center justify-center shadow-md">
                    <Icon size={20} />
                  </div>

                  <h3 className="text-lg font-bold text-gray-900 mb-2">
                    {item.title}
                  </h3>

                  <p className="text-sm text-gray-600 leading-relaxed">
                    {item.desc}
                  </p>
                </motion.div>
              );
            })}
          </div>
        </div>

      </div>
    </section>
    </>
  );
};

export default HalalCertification;
